import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormArray, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CotizacionesService } from '../../Service/cotizaciones-service';
import { ToastService } from '../../Service/toast-service';
import { Cotizacion, CotizacionDetalle } from '../../Cotizacion/models/cotizacion';
import { UdcsService } from '../../Service/udcs-service';
import { RecepcionesService } from '../../Service/recepciones-service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cotizaciones-edit',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './cotizaciones-edit.html',
  styleUrl: './cotizaciones-edit.css',
})
export class CotizacionesEdit implements OnInit {
  public editForm!: FormGroup;
  public idCotizacion!: number;
  public folioCotizacion: string = 'S/F';
  public ivaIncluido: boolean = false;
  public cargando: boolean = true;

  public currentVehicleSvg: string = 'images/croquis-sedan.svg';
  public datosCarroceriaPatio: any[] = [];
  public intentarGuardar: boolean = false; // 🚀 Alerta visual en cascada

  private mapperCarroceria: { [key: string]: string } = {
    'Sedán': 'sedan', 
    'Pickup': 'pickup', 
    'SUV': 'suv', 
    'Camión': 'camion', 
    'Autobús': 'autobus'
  };  

  listaUdcsGravedad: any[] = [];

  public data: any = { fotos: [] }; // Almacena el expediente con las fotos sanitizadas
  public mostrarVisorFotos: boolean = false;
  public indiceFotoActual: number = 0;  

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private recepcionesService: RecepcionesService,
    private cotizacionesService: CotizacionesService,
    public toastService: ToastService,
    private udcsService: UdcsService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer // 👈 2. INYECTAR EN CONSTRUCTOR
  ) {}

  ngOnInit(): void {
    this.idCotizacion = +this.route.snapshot.params['id'];
    this.inicializarFormulario();
    this.cargarDatosCotizacion();
  }

  private inicializarFormulario(): void {
    this.editForm = this.fb.group({
      id: [this.idCotizacion],
      idRecepcion: [{ value: '', disabled: true }],
      vigenciaDias: [15, [Validators.required, Validators.min(1)]],
      subtotal: [{ value: 0, disabled: true }],
      iva: [{ value: 0, disabled: true }],
      total: [{ value: 0, disabled: true }],
      comentariosCliente: [''],
      estatusAprobacion: [''],
      tokenAprobacion: [''],
      lineas: this.fb.array([])
    });

    this.editForm.get('comentariosCliente')?.valueChanges.subscribe(valor => {
      if (valor && valor !== valor.toUpperCase()) {
        this.editForm.get('comentariosCliente')?.setValue(valor.toUpperCase(), { emitEvent: false });
      }
    });    
  }

  get lineas(): FormArray {
    return this.editForm.get('lineas') as FormArray;
  }

  private cargarDatosCotizacion(): void {
    console.log('📡 [SaaS Adjuster] 1. Descargando matriz de tarifas UDC por Tenant (TALLER/GRAVEDAD)...');
    
    // 🔮 FASE 1: Consultamos las tarifas parametrizadas del inquilino logueado
    this.udcsService.getTarifasUdc().subscribe({ // Apunta al endpoint multi-tenant de UDCs
      next: (tarifasUdc: any[]) => {
        this.listaUdcsGravedad = tarifasUdc || [];
        console.log(`💰 [SaaS Adjuster] Tarifas del taller indexadas en RAM. Renglones: ${this.listaUdcsGravedad.length}`);
        
        // Ejecutamos la consulta del expediente una vez que las tarifas están listas en memoria
        this.ejecutarConsultaExpedientePresupuesto();
      },
      error: (err) => {
        console.error('⚠️ [SaaS Adjuster] No se pudieron precargar las UDCs por Tenant. Se usarán tarifas de respaldo.', err);
        // Resiliencia ERP: Continuamos la carga de la pantalla usando los fallbacks de seguridad
        this.ejecutarConsultaExpedientePresupuesto();
      }
    });
  }

  private ejecutarConsultaExpedientePresupuesto(): void {
    console.log(`📶 [SaaS Adjuster] 2. Despachando consulta HTTP GET para Cotización ID: ${this.idCotizacion}`);
    
    this.cotizacionesService.getById(this.idCotizacion).subscribe({
      next: (cotiz: Cotizacion) => {
        if (!cotiz) {
          this.toastService.showDanger('Error de Sincronización', 'El expediente comercial no devolvió datos.');
          this.router.navigate(['/cotizaciones']);
          return;
        }

        // 🔍 AUDITORÍA DE PINES: Imprime el objeto completo en la consola de Chrome para inspeccionar sus llaves
        console.log('📥 [SaaS AUDITORÍA] Objeto completo recibido del servidor:', cotiz);
        console.log('📥 [SaaS AUDITORÍA] Nodo recepcion:', cotiz.recepcion);
        if (cotiz.recepcion) {
          console.log('📥 [SaaS AUDITORÍA] detallesCarroceria dentro de recepcion:', cotiz.recepcion.detallesCarroceria);
        }

        this.folioCotizacion = cotiz.folioCotizacion || 'S/F';

        // 🚀 INYECTADO: Rellenamos la propiedad data para el carrusel de evidencias fotográficas
        //this.data = cotiz.recepcion || { fotos: [] };

        // 🚀 INYECCIÓN MAESTRA Y EXTRACCIÓN DE IMÁGENES DE PATIO ORIGINALES
        // Transformamos las entidades LAZY del backend a URLs absolutas legibles por el HTML
        
  
        

        //const recepcionCruda = cotiz.recepcion as any;
        
/*         if (recepcionCruda && recepcionCruda.fotos && recepcionCruda.fotos.length > 0) {
          console.log('📥 [SaaS Fotos] Evidencias crudas localizadas en el expediente de patio:', recepcionCruda.fotos);
          
        this.data = {
          fotos: recepcionCruda.fotos.map((f: any) => {
            // 🚀 Sincronizado con la llave del JSON real 'urlFoto'
            const archivoNombre = f.urlFoto || f.nombreFoto || ''; 
            
            // 🚀 Sincronizado con la ruta '/uploads/' que sí funciona en el otro TS
            const rutaCompleta = `/uploads/${f.urlFoto}`;
            
            return {
              // 🚀 Sello de seguridad inyectado con bypassSecurityTrustUrl
              urlSanitizada: archivoNombre 
                ? this.sanitizer.bypassSecurityTrustUrl(rutaCompleta)
                : 'images/default-placeholder.jpg'
            };
          })
        };
          
          console.log(`✅ [SaaS Fotos SUCCESS] Arreglo hidratado con éxito para el Lightbox. Total imágenes: ${this.data.fotos.length}`);
        } else {
          console.warn('⚠️ [SaaS Fotos] El expediente de esta cotización no contiene evidencias fotográficas de entrada.');
          this.data = { fotos: [] };
        }   */
        



        // Mapeamos los parámetros comerciales a los controles reactivos del formulario
        this.editForm.patchValue({
          idRecepcion: cotiz.idRecepcion,
          vigenciaDias: cotiz.vigenciaDias,
          comentariosCliente: cotiz.comentariosCliente,
          estatusAprobacion: cotiz.estatusAprobacion,
          tokenAprobacion: cotiz.tokenAprobacion
        });
        
        // 📋 FASE 4: CARGA Y RE-CÁLCULO EN CALIENTE DE LAS PARTIDAS EXISTENTES
        if (cotiz.lineas && cotiz.lineas.length > 0) {
          cotiz.lineas.forEach(linea => this.agregarLineaAlFormArray(linea));
        }

        // 🛡️ REGLA DE INTEGRIDAD COMERCIAL: Congelamiento automático si está pendiente por el cliente
        if (!cotiz.estatusAprobacion || cotiz.estatusAprobacion === 'Pendiente') {
          // Desactivamos el formulario reactivo de golpe para bloquear manipulación de celdas
          this.editForm.disable();
          this.lineas.controls.forEach(c => c.disable());
          console.log('🔒 [SaaS Adjuster] Formulario congelado: Pendiente de autorización por cliente.');
        }

        // 🚀 FASE MAESTRA DE ROBUSTEZ: Descarga cruzada del croquis de patio original usando idRecepcion
        console.log(`🛰️ [SaaS Cross-Link] Solicitando expediente de patio original para Recepcion ID: ${cotiz.idRecepcion}`);
        this.recepcionesService.getRecepcionesList().subscribe({
          next: (todasLasRecepciones: any[]) => {
            const recepcionOriginalPatio = todasLasRecepciones.find(r => r.id === cotiz.idRecepcion);
            
            if (recepcionOriginalPatio) {
              console.log('📥 [SaaS Cross-Link] Registro de patio recuperado con éxito:', recepcionOriginalPatio);
              


              // =========================================================================
              // 🌟 SOLUCIÓN AL PROBLEMA DE FOTOS: Extraer las evidencias del nodo correcto
              // =========================================================================
              if (recepcionOriginalPatio.fotos && recepcionOriginalPatio.fotos.length > 0) {
                console.log('📥 [SaaS Fotos Cross-Link] Localizando fotos en el registro de patio recuperado:', recepcionOriginalPatio.fotos);
                
                this.data = {
                  fotos: recepcionOriginalPatio.fotos.map((f: any) => {
                    const archivoNombre = f.urlFoto || f.nombreFoto || '';
                    const rutaCompleta = `/uploads/${archivoNombre}`;
                    
                    return {
                      urlSanitizada: archivoNombre 
                        ? this.sanitizer.bypassSecurityTrustUrl(rutaCompleta)
                        : 'images/default-placeholder.jpg'
                    };
                  })
                };
                console.log(`✅ [SaaS Fotos SUCCESS] Galería cargada desde Cross-Link de Patio. Total: ${this.data.fotos.length}`);
              } else {
                console.warn('⚠️ [SaaS Fotos] El registro de patio encontrado no tiene fotos vinculadas.');
                this.data = { fotos: [] };
              }



              // 🎯 CLONACIÓN DE PINES ORIGINALES EN SNAKE_CASE / CAMELCASE
              this.datosCarroceriaPatio = recepcionOriginalPatio.detallesCarroceria ? [...recepcionOriginalPatio.detallesCarroceria] : [];
              
              // RESOLUCIÓN DE SILUETA DINÁMICA
              const siluetaBase = recepcionOriginalPatio.tipoSilueta || (recepcionOriginalPatio.unidad?.tipoCarroceria ? recepcionOriginalPatio.unidad.tipoCarroceria : 'Sedán');
              const nombreArchivoSvg = this.mapperCarroceria[siluetaBase] || 'sedan';
              this.currentVehicleSvg = `images/croquis-${nombreArchivoSvg}.svg`;
              
              console.log(`✅ [SaaS Cross-Link] Croquis montado: ${this.currentVehicleSvg}. Pines reactivos renderizados: ${this.datosCarroceriaPatio.length}`);
            } else {
              console.warn('⚠️ [SaaS Cross-Link] No se encontró la recepción correlativa en el patio.');
            }

            // 🛡️ REGLA DE INMUTABILIDAD: Forzamos al formulario a limpiarse tras cargar todo de la DB
            // Esto asegura que editForm.pristine sea TRUE de arranque y frena el botón Actualizar
            this.editForm.markAsPristine();
            this.calcularTotales();
            this.cargando = false;
            this.cdr.markForCheck();
            this.cdr.detectChanges(); // Fuerza a Angular a esparcir los pines sobre el carro
          },
          error: (err) => {
            console.error('❌ Error al cruzar datos con el listado de patio:', err);
            this.editForm.markAsPristine();
            this.calcularTotales();
            this.cargando = false;
            this.cdr.detectChanges();
          }
        });
      },
      error: (err) => {
        console.error('❌ [SaaS Adjuster] Error crítico al descargar cotización de la DB:', err);
        this.toastService.showDanger('Fallo de Sincronización', 'No se pudo conectar con el microservicio comercial.');
        this.router.navigate(['/cotizaciones']);
      }
    });
  }

  private agregarLineaAlFormArray(l: CotizacionDetalle): void {
    const fLinea = this.fb.group({
      id: [l.id],
      tipoItem: [l.tipoItem, Validators.required],
      codigoInterno: [l.codigoInterno],
      descripcion: [l.descripcion, Validators.required],
      cantidad: [l.cantidad, [Validators.required, Validators.min(0.01)]],
      precioUnitario: [l.precioUnitario, [Validators.required, Validators.min(0)]],
      descuento: [l.descuento || 0, [Validators.required, Validators.min(0)]],
      subtotalLinea: [{ value: l.subtotalLinea || 0, disabled: true }],
      aprobadoPorCliente: [l.aprobadoPorCliente],
      idCarroceriaLink: [l.idCarroceriaLink] // Mapeo Modalidad A/B
    });

    // Forzar Mayúsculas en descripciones modificadas en caliente dentro de la cuadrícula
    fLinea.get('descripcion')?.valueChanges.subscribe(valor => {
      if (valor && valor !== valor.toUpperCase()) {
        fLinea.get('descripcion')?.setValue(valor.toUpperCase(), { emitEvent: false });
      }
    });

    fLinea.valueChanges.subscribe(() => this.calcularTotales());
    this.lineas.push(fLinea);
  }

  public agregarNuevaLineaNueva(tipo: 'Refaccion' | 'Mano de Obra' | 'Servicio Externo'): void {
    this.agregarLineaAlFormArray({
      tipoItem: tipo,
      descripcion: '',
      cantidad: 1,
      precioUnitario: 0,
      descuento: 0,
      aprobadoPorCliente: true,
      idCarroceriaLink: null
    });
    // Forzamos a Angular a habilitar el botón al ensuciar el formulario
    this.editForm.markAsDirty();
    this.cdr.detectChanges();    
  }

  public removerLinea(index: number): void {
    this.lineas.removeAt(index);
    this.calcularTotales();
  }

  public conmutarIvaSwitch(): void {
    this.lineas.controls.forEach(control => {
      const precio = control.get('precioUnitario')?.value || 0;
      if (this.ivaIncluido) {
        control.get('precioUnitario')?.setValue(+(precio * 1.16).toFixed(2), { emitEvent: false });
      } else {
        control.get('precioUnitario')?.setValue(+(precio / 1.16).toFixed(2), { emitEvent: false });
      }
    });
    this.calcularTotales();
  }

  public calcularTotales(): void {
    let subtotalAcumulado = 0;

    this.lineas.controls.forEach(control => {
      const cantidad = control.get('cantidad')?.value || 0;
      let precioUnitario = control.get('precioUnitario')?.value || 0;
      const descuento = control.get('descuento')?.value || 0;
      const aprobado = control.get('aprobadoPorCliente')?.value;

      if (this.ivaIncluido) {
        precioUnitario = precioUnitario / 1.16;
      }

      const subtotalLinea = (cantidad * precioUnitario) - descuento;
      control.get('subtotalLinea')?.setValue(+subtotalLinea.toFixed(2), { emitEvent: false });

      if (aprobado) {
        subtotalAcumulado += subtotalLinea;
      }
    });

    const ivaCalculado = subtotalAcumulado * 0.16;
    const totalCalculado = subtotalAcumulado + ivaCalculado;

    this.editForm.patchValue({
      subtotal: +subtotalAcumulado.toFixed(2),
      iva: +ivaCalculado.toFixed(2),
      total: +totalCalculado.toFixed(2)
    }, { emitEvent: false });
  }


  public guardarCambios(): void {
    // 🛡️ Candado de Inmutabilidad: Si el formulario está intacto, frena la transacción de inmediato
    if (this.editForm.pristine) {
      console.log('🚫 [SaaS Adjuster] Envío abortado: No se detectaron modificaciones en el presupuesto.');
      return;
    }
        
    this.intentarGuardar = true; // 🚀 Activa de inmediato las alertas visuales .is-invalid en el HTML
    
    // 🛡️ VALIDACIÓN 1: Forzar renglón comercial obligatorio en la edición
    if (this.lineas.length === 0) {
      this.toastService.showDanger(
        'Partidas Requeridas', 
        'No se puede guardar un presupuesto vacío. Ingrese al menos un renglón detallando el trabajo.'
      );
      this.cdr.detectChanges();
      return;
    }

    // 🛡️ VALIDACIÓN 2: Bloqueo de celdas obligatorias incompletas o vacías
    if (this.editForm.invalid) {
      // Recorremos y forzamos el marcado en rojo interactivo de cada control de las partidas
      this.editForm.markAllAsTouched();
      this.lineas.controls.forEach(control => {
        control.get('descripcion')?.markAsTouched();
        control.get('cantidad')?.markAsTouched();
        control.get('precioUnitario')?.markAsTouched();
      });
      
      this.toastService.showDanger(
        'Formulario Inválido', 
        'Por favor, capture la información en las celdas obligatorias marcadas en rojo.'
      );
      
      // 🚀 INYECCIÓN SÍNCRONA: Obliga a Angular a repintar el DOM con los bordes rojos de inmediato
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      return;
    }

    // Clonación segura del payload para la transmisión de red
    const payload = { ...this.editForm.getRawValue() };
    
    // Si se editó con el switch activo, extraemos el neto contable antes de persistir en MySQL
    if (this.ivaIncluido) {
      payload.lineas = payload.lineas.map((l: any) => ({
        ...l,
        precioUnitario: +(l.precioUnitario / 1.16).toFixed(2)
      }));
    }

    console.log('🚀 Despachando actualización comercial a Spring Boot:', payload);

    // Invocación HTTP segura hacia el endpoint unificado del Backend
    this.cotizacionesService.save(payload).subscribe({
      next: (res) => {
        this.toastService.showSuccess(
          'Ajuste Guardado', 
          `El presupuesto con folio comercial ${this.folioCotizacion} fue actualizado con éxito.`
        );
        this.router.navigate(['/cotizaciones']); // Retorna en verde a la matriz comercial
      },
      error: (err) => {
        console.error('Error crítico al actualizar el presupuesto:', err);
        this.toastService.showDanger(
          'Error de Persistencia', 
          'El microservicio rechazó la actualización comercial. Verifique la inmutabilidad del folio.'
        );
        this.cdr.detectChanges();
      }
    });
  }

  public vincularPinACotizacion(pin: any): void {
    // 🛡️ Extracción tolerante a snake_case y camelCase heredada del patio
    const tipoDanoReal = pin.tipo_dano || pin.tipoDano || 'DAÑO';
    const descripcionReal = pin.descripcion || 'REPARACIÓN ESTÍTICA';
    const gravedadReal = (pin.gravedad || 'MEDIA').toUpperCase();
    const pinIdReal = pin.id;

    console.log(`📌 [SaaS Adjuster] Procesando Modalidad A para Pin ID #${pinIdReal} (${tipoDanoReal}) - Gravedad: ${gravedadReal}`);

    // 1. Fallback por defecto (Valores originales de seguridad si el Tenant no tiene la UDC)
    let costoSugerido = 1200;
    if (gravedadReal === 'ALTA') costoSugerido = 3500;
    else if (gravedadReal === 'MEDIA') costoSugerido = 2200;

    // 2. 🔮 Sincronización Multi-Tenant: Si el taller tiene sus propios precios en la UDC, los aplica
    if (this.listaUdcsGravedad && this.listaUdcsGravedad.length > 0) {
      const configUdc = this.listaUdcsGravedad.find(u => u.strValue1.toUpperCase() === gravedadReal);
      if (configUdc && configUdc.intValue > 0) {
        costoSugerido = configUdc.intValue;
        console.log(`💰 [SaaS Adjuster] Tarifa personalizada aplicada desde UDC del Tenant: $${costoSugerido}.00`);
      }
    }

    const descripcionPropuesta = `REPARACIÓN Y LAMINADO DE ${tipoDanoReal.toUpperCase()} - ${descripcionReal.toUpperCase()}`;
    
    // 3. Inyectamos la línea contable al FormArray de edición amarrando la FK 'idCarroceriaLink'
    this.agregarNuevaLineaNueva('Mano de Obra');
    const ultimaLinea = this.lineas.at(this.lineas.length - 1);
    ultimaLinea.patchValue({
      descripcion: descripcionPropuesta,
      precioUnitario: costoSugerido,
      idCarroceriaLink: pinIdReal
    });

    // 🚀 DISPARO INMEDIATO: El Toast emerge en pantalla en el instante del clic
    this.toastService.showSuccess('Línea Acoplada', `Daño por ${tipoDanoReal.toUpperCase()} inyectado síncronamente al ajuste con tarifa de Gravedad ${gravedadReal}.`);
    
    // Forzamos a Angular a habilitar el botón al ensuciar el formulario por el clic del croquis
    this.editForm.markAsDirty();

    // Forzamos la actualización inmediata en la interfaz gráfica
    this.calcularTotales();
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  // En tu cotizaciones-edit.ts actualiza el método alCancelar:
  public alCancelar(): void {
    console.log('🧭 Cancelando ajuste comercial. Retornando a la matriz de cotizaciones.');
    this.router.navigate(['/cotizaciones']);
  }

  public abrirVisorEnFoto(foto: any): void {
    const index = this.data?.fotos?.indexOf(foto);
    if (index !== undefined && index !== -1) {
      this.indiceFotoActual = index;
      this.mostrarVisorFotos = true;
    }
  }

  public cerrarVisor(): void {
    this.mostrarVisorFotos = false;
  }

  public fotoSiguiente(event: MouseEvent): void {
    event.stopPropagation(); // Evita que se cierre el modal flotante
    if (this.data?.fotos && this.indiceFotoActual < this.data.fotos.length - 1) {
      this.indiceFotoActual++;
    } else {
      this.indiceFotoActual = 0; // Carrusel infinito: regresa al inicio
    }
  }

  public fotoAnterior(event: MouseEvent): void {
    event.stopPropagation();
    if (this.data?.fotos && this.indiceFotoActual > 0) {
      this.indiceFotoActual--;
    } else {
      this.indiceFotoActual = this.data.fotos.length - 1; // Carrusel infinito: va al final
    }
  }  
  
}
